import styled from "styled-components/macro";

export const NavContainer = styled.nav<{isMainPage?: boolean}>`
  height:  ${({ isMainPage }) => isMainPage ? "32px" : "70px"};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ isMainPage }) => isMainPage ? "0" : "12px"};
    
  @media (max-width: 1439px) {
    height:  ${({ isMainPage }) => isMainPage ? "32px" : "56px"};
    margin-bottom: 0;
  }
`;

export const Circle = styled.div`
  background-color: #55749f;
  height: 8px;
  width: 8px;
  border-radius: 8px;
`;

export const BreadcrumbsList = styled.ul`
  display: flex;
  align-items: center;
  list-style-position: inside;
  list-style-type: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-transform: uppercase;

  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

export const Alink = styled.a<{isActive?: boolean}>`
  text-decoration: none;
  color: ${({ isActive }) => isActive ? "#55749f" : "#141414"};
  list-style-position: inside;
  margin-left: 5px;
  cursor: pointer;

  &:hover {
    color: #55749f;
  }
`;
